import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { SocialProofBar } from '../../components/SocialProofBar';
import { TrustBadges } from '../../components/TrustBadges';
export function MartialArtsNearMeHeroInfo() {
  return <div className="flex flex-col items-start" data-id="element-2460">
      <div className="inline-block bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-2461">
        Martial Arts Near You
      </div>
      <div className="mb-8" data-id="element-2462">
        <SocialProofBar data-id="element-2463" />
      </div>
      <h1 className="text-5xl md:text-6xl text-white mb-6 leading-[1.1]" data-id="element-2464">
        Martial Arts Classes Near Me in Farmington Hills
      </h1>
      <p className="text-xl text-off-white mb-8 max-w-xl leading-relaxed" data-id="element-2465">
        Storm Taekwondo offers beginner-friendly martial arts classes for kids,
        adults and families in Farmington Hills, Novi, Commerce, Walled Lake,
        Wixom, Livonia, Northville, Waterford, White Lake, Milford, West
        Bloomfield and nearby Southeast Michigan.
      </p>

      <ul className="flex flex-col gap-3 mb-10" data-id="element-2466">
        {['Core martial arts stances, blocks, and strikes', 'Dynamic kicking techniques unique to Taekwondo', 'How to set and achieve long-term goals', 'Respect, courtesy, and self-control'].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-white text-lg" data-id="element-2467">
            <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0" data-id="element-2468" />
            <span data-id="element-2469">{item}</span>
          </li>)}
      </ul>

      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-10" data-id="element-2470">
        <Link to="/SignMeUp" className="btn-primary" data-id="element-2471">
          Find the Right Class or Program
        </Link>
        <a href="tel:517-220-0621" className="btn-secondary" data-id="element-2472">
          Call 517-220-0621
        </a>
      </div>
      <TrustBadges data-id="element-2473" />
    </div>;
}